<template>
  <div>
    <v-card>
      <!-- <v-card-title> -->
      <v-row class="pa-5">
        <v-col cols="10" class="float-right text-right">
          <v-tabs v-model="tab" show-arrows>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#InfoDetail">
              <h6>جزییات</h6>
            </v-tab>
            <v-tab href="#Message">
              <h6>پیام ها</h6>
            </v-tab>
            <v-tab href="#Event">
              <h6>سوابق</h6>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="2" class="float-left text-left">
          <v-btn color="error" @click="closeForm()" icon>
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item :value="'InfoDetail'">
          <v-card-text flat>
            <trade-request-information></trade-request-information>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Message'">
          <v-card-text flat>
            <trade-request-chats-with-admin-list
              :tradeRequestChatWithAdminList="tradeRequestChatWithAdminList"
              @getTradeRequestChatsWithAdmin="getTradeRequestChatsWithAdmin"
            >
            </trade-request-chats-with-admin-list>
          </v-card-text>
        </v-tab-item>
        <v-tab-item :value="'Event'">
          <v-card-text flat>
            <trade-request-events></trade-request-events>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import Helper from '@/core/helpers';
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
import TradeRequestForm from '@/modules/tradeRequests/components/TradeRequestForm.vue';
import TradeRequestInformation from '../components/TradeRequestInformation.vue';
import TradeRequestEvents from '../components/TradeRequestEvents.vue';
import TradeRequestChatsWithAdminList from '../tradeRequsetChatWithAdmin/components/TradeRequestChatsWithAdminList.vue';
export default {
  data() {
    return {
      eventModal: false,
      tradeRequestChatWithAdminList: [],
    };
  },
  components: {
    TradeRequestForm,
    TradeRequestInformation,
    TradeRequestEvents,
    TradeRequestChatsWithAdminList,
  },
  created() {
    this.getTradeRequestChatsWithAdmin();
  },
  computed: {
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    id() {
      return this.$route.params.id;
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
  },
  methods: {
    showDetailForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', true);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
    },
    closeForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$router.push({ path: '/trade-request' });
    },
    getTradeRequestChatsWithAdmin() {
      const loader = this.$loading.show();
      let param = {
        tradeRequestId: this.id,
      };
      tradeRequestChatWithAdminRepository()
        .getTradeRequestChatsWithAdmin(this.baseUrl, {}, param)
        .then((res) => {
          this.tradeRequestChatWithAdminList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    openPickAdminModal() {
      this.pickAdminModal = true;
    },
    closePickAdminDialog() {
      this.pickAdminModal = false;
    },
  },
};
</script>

<style></style>
